// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legendContainer__OfU87 {
  position: absolute;
  top: 25px;
  right: 30px;
  color: var(--inputs-filled-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.11px;
  width: 220px;
}

.legendTitleContainer__uhwJV {
  display: flex;
  height: 35px;
  border-radius: 2px;
  background: var(--header-elevation);
  align-items: center;
  justify-content: space-between;
  padding: 0px 5px 0px 10px;
  margin-bottom: 5px;
}

.arrowIcon__cCqwC {
  transform: rotateX(180deg);
  transition: transform 0.5s;
  cursor: pointer;
  stroke: var(--header-icon-secondary);
}

.openedArrowIcon__iHvCB {
  transform: rotateX(0);
}

.legendItemContainer__dJgGx {
  display: flex;
  padding: 10px;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: rgba(var(--map-legend-item-background-rgb), 1);
}
.legendItemContainer__dJgGx:last-child {
  border-bottom: unset;
}
@media (max-width: 1280px) {
  .legendItemContainer__dJgGx {
    border-bottom: unset;
    background: rgba(var(--map-legend-item-background-rgb), 0.302);
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/common/Maps/components/MapLegend/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;AA1EF;;AA6EA;EACE,0BAAA;EACA,0BAAA;EACA,eAAA;EACA,oCAAA;AA1EF;;AA6EA;EACE,qBAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,yDAAA;EACA,0DAAA;AA1EF;AA4EE;EACE,oBAAA;AA1EJ;AA6EE;EAbF;IAcI,oBAAA;IACA,8DAAA;EA1EF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.legendContainer {\n  position: absolute;\n  top: 25px;\n  right: 30px;\n\n  color: var(--inputs-filled-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.11px;\n  width: 220px;\n}\n\n.legendTitleContainer {\n  display: flex;\n  height: 35px;\n  border-radius: 2px;\n  background: var(--header-elevation);\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 5px 0px 10px;\n  margin-bottom: 5px;\n}\n\n.arrowIcon {\n  transform: rotateX(180deg);\n  transition: transform 0.5s;\n  cursor: pointer;\n  stroke: var(--header-icon-secondary);\n}\n\n.openedArrowIcon {\n  transform: rotateX(0);\n}\n\n.legendItemContainer {\n  display: flex;\n  padding: 10px;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: rgba(var(--map-legend-item-background-rgb), 1);\n\n  &:last-child {\n    border-bottom: unset;\n  }\n\n  @media (max-width: 1280px) {\n    border-bottom: unset;\n    background: rgba(var(--map-legend-item-background-rgb), 0.302);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legendContainer": `legendContainer__OfU87`,
	"legendTitleContainer": `legendTitleContainer__uhwJV`,
	"arrowIcon": `arrowIcon__cCqwC`,
	"openedArrowIcon": `openedArrowIcon__iHvCB`,
	"legendItemContainer": `legendItemContainer__dJgGx`
};
module.exports = ___CSS_LOADER_EXPORT___;
